import { useCommerceRewardCollection } from "../../../logic/hooks/useCommerceRewardCollection";
import { RewardCollectionDialog } from "../../common/RewardCollectionDialog/RewardCollectionDialog";

/** One app-level owner presents purchases from both Main and Career routes. */
export function CommerceRewardCollection() {
    const collection = useCommerceRewardCollection();
    return (
        <RewardCollectionDialog
            presentation={collection.presentation}
            onCollect={collection.fadeSound}
            onComplete={collection.complete}
        />
    );
}
